module.exports = "pegasus/assets/themelp1/webinar/105.png";